(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["offer-coupon-cards"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__tatsaOfferCopyReady) return;
    window.__tatsaOfferCopyReady = true;

    const fallbackCopy = (text) => {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      textarea.style.pointerEvents = 'none';
      document.body.appendChild(textarea);
      textarea.select();
      const copied = document.execCommand('copy');
      textarea.remove();
      return copied;
    };

    const copyText = async (text) => {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return true;
      }

      return fallbackCopy(text);
    };

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-tatsa-copy-code]');
      if (!button) return;

      const code = button.dataset.tatsaCopyCode || '';
      if (!code) return;

      try {
        const copied = await copyText(code);
        if (!copied) return;

        const value = button.querySelector('[data-tatsa-code-value]');
        const success = button.querySelector('[data-tatsa-code-success]');

        if (value) value.hidden = true;
        if (success) success.hidden = false;
        button.setAttribute('aria-label', button.dataset.tatsaCopiedLabel || 'Coupon code copied');

        window.clearTimeout(button.__tatsaCopyTimeout);
        button.__tatsaCopyTimeout = window.setTimeout(() => {
          if (value) value.hidden = false;
          if (success) success.hidden = true;
          button.setAttribute('aria-label', button.dataset.tatsaCopyLabel || `Copy coupon code ${code}`);
        }, 1600);
      } catch (error) {
        fallbackCopy(code);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
